import React, { useState } from 'react';
import type { TProviderRecentlyWorked } from '../../home/types';
import { Select, Stack, Text } from 'library/ui';
import { IProviderReviewOption } from 'models';
import ProviderReviewModalLine from './ProviderReviewModalLine';
import WorkerReviewCopy from 'parent-portal/shared/WorkerReviewCopy';

export default function ProviderReviewModalList({
    workers,
    options,
}: {
    workers: TProviderRecentlyWorked[];
    options: IProviderReviewOption[];
}) {
    const uniqueLocations = workers
        .flatMap((worker) => worker.appointments)
        .reduce((locations: { id: number; name: string }[], appt) => {
            const isNew = !locations.some((loc) => appt.location.id === loc.id);
            return isNew ? [...locations, appt.location] : locations;
        }, []);

    const [selectedCenter, setSelectedCenter] = useState(uniqueLocations[0]?.id);

    const getWorkersAtCenter = (centerId: number) => {
        return workers.filter((worker) => {
            return worker.appointments.some((appt) => appt.location.id === centerId);
        });
    };

    return (
        <Stack gap="md">
            <WorkerReviewCopy />
            <Select
                value={selectedCenter ?? ''}
                disabled={uniqueLocations.length <= 1}
                options={uniqueLocations.map((center) => ({
                    key: center.id,
                    value: `${center.name} (${getWorkersAtCenter(center.id)?.length})`,
                }))}
                onChange={(value) => setSelectedCenter(Number(value))}
            />
            <Stack gap="lg">
                {(selectedCenter ? getWorkersAtCenter(selectedCenter) : workers)?.map((worker) => (
                    <ProviderReviewModalLine
                        key={worker.id}
                        worker={worker}
                        options={options}
                        businessLocationId={selectedCenter}
                    />
                ))}
            </Stack>
            <Text size="sm" tone="secondary">
                *If you aren&apos;t the admin that supervised these workers, don&apos;t leave them a review.
            </Text>
        </Stack>
    );
}
